







































































import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Form101DataModel } from '@/models/form/Form101Data.model';
import { FORM101_DATA, OPEN_REJECT_FORM_DIALOG, SET_OPEN_REJECT_FORM_DIALOG } from '@/types/form.types';
import {
  FORM_101_REJECT_REASON,
  MANAGER_LOADING,
  REJECT_FORM,
  REJECT_FORM_ERRORS, SET_MANAGER_LOADING,
} from '@/types/managerForm.types';
import Spinner from '@/components/loading/Spinner.vue';

@Component({
  components: {
    Spinner,
  },
})
export default class RejectFormModal extends Vue {
  @Inject() public $validator;

  @Action(REJECT_FORM, StoreNamespace.MANAGER) public rejectForm;

  @Mutation(SET_OPEN_REJECT_FORM_DIALOG, StoreNamespace.FORM) public setOpenRejectFormDialog;
  @Mutation(SET_MANAGER_LOADING, StoreNamespace.MANAGER) public setManagerLoading;

  @Getter(OPEN_REJECT_FORM_DIALOG, StoreNamespace.FORM) public openRejectFormDialog!: boolean;
  @Getter(FORM101_DATA, StoreNamespace.FORM) public form101Data!: Form101DataModel;
  @Getter(REJECT_FORM_ERRORS, StoreNamespace.MANAGER) public serverErrorMessages!: string[];
  @Getter(FORM_101_REJECT_REASON, StoreNamespace.MANAGER) public form101RejectReason!: string;
  @Getter(MANAGER_LOADING, StoreNamespace.MANAGER) public managerLoading!: boolean;


  public rejectedReasonText: string = '';

  public created() {
    this.rejectedReasonText = this.form101RejectReason;
  }

  public closeDialog(): void {
    this.setOpenRejectFormDialog(false);
  }

  public confirmDialog(): void {
    this.setManagerLoading(true);
    this.$validator.validateAll('rejectForm').then((result: any) => {
      if (!result) {
        setTimeout(() => {
          this.setManagerLoading(false);
          const firstInput: HTMLElement = document.querySelectorAll('label.is-error')[0] as HTMLElement;
          if (firstInput) {
            firstInput.focus();
          }
        });
      } else {
        this.rejectForm({
          formId: this.form101Data.formId,
          officeNum: this.form101Data.officeNum,
          idNum: this.form101Data.idNum,
          positionNum: this.form101Data.positionNum,
          rejectedReasonText: this.rejectedReasonText,
        });
      }
    });
  }

  @Watch('form101RejectReason')
  public form101RejectReasonChanged() {
    this.rejectedReasonText = this.form101RejectReason;
  }

  public destroyed() {
    this.setOpenRejectFormDialog(false);
  }

}
